import { Component, OnInit, OnDestroy, Optional, Inject, Input } from '@angular/core';
import { PershingTranslationService, INavigationService } from '@pershing/pershing-core';
import { NxiNavigation } from '@pershing/nxi-common';
import { Location } from '@angular/common';
import { NavigationBaseComponent } from './navigation-base.component';
import { NavigationConstants } from '../utils/navigation.constants';

@Component({
    selector: 'portal-navigation',
    templateUrl: 'navigation.component.html'
})
export class NavigationComponent extends NavigationBaseComponent implements OnDestroy, OnInit {
    menuItems: any[];
    selectedPageId: string;
    selectedPage: any;
    navigation: NxiNavigation;
    linkUrl: string;
    @Input() showLanguageSwitch: boolean = false;
    ibdConfigMap: any;
    showPostLogin: boolean = true;
    showAdvisorIcon: boolean = true;
    advisorText: any;
    constructor(
        private translationService: PershingTranslationService,
        protected navigationService: INavigationService,
        @Optional() @Inject('AppSettings') appSettings: any,
        protected location: Location) {
        super(navigationService, location, appSettings);
        this.ibdConfigMap = appSettings.ibdConfigMap;
        this.linkUrl = appSettings.postLoginEquiptUrl;
        this.translationService.addTranslationFolder('@pershing/nxi-navigation', 'node_modules/@pershing/nxi-navigation/lib');
        this.advisorText = 'NXI_NAVIGATION.ADVISORHOME';
        if (NavigationConstants.propertyMap.get(this.ibdConfigMap.community) && NavigationConstants.propertyMap.get(this.ibdConfigMap.community).get('Advisor')) {
            this.advisorText = NavigationConstants.propertyMap.get(this.ibdConfigMap.community).get('Advisor');
            if(NavigationConstants.propertyMap.get(this.ibdConfigMap.community).get('showIcon') !== 'true') {
                this.showAdvisorIcon = false;
            }
            
        }
        this.navigationService.getMenuConfigurations().subscribe(data => {
                let url = this.location.path(false);
                let urlArray = url.split('/');
                if (urlArray[2] === 'disclosure') {
                    this.showPostLogin = false;
                } else {
                    this.showPostLogin = true;
                }
                this.menuItems = data;
                this.selectedPageId = this.navigationService.getParentPageId();
            }
        );
        this.navigationService.getParentPage().subscribe(childpage => {
            if (childpage) {
                this.selectedPageId = childpage.id;
            }
        });
    }

    handleNavigation(parentpage: any): void {
        this.navigation = new NxiNavigation();
        this.selectedPageId = parentpage.id;
        this.navigation.parentPage = parentpage;
        this.navigationService.handleNavigation(this.navigation);
    }
    handleNavigationLink(parentpage: any): void {
        if (parentpage.id === 'equipt') {
            window.location.href = parentpage.LinkUrl;
        } else {
            window.open(parentpage.LinkUrl);
        }
        return;
    }

    ngOnInit() {
        super.ngOnInit();
    }
    ngOnDestroy() {
        console.log(' In Component Destroy ');
    }
}
